import axios from "axios";

export interface IAdminSession {
  id: string;
  user_name: string;
  email: string;
}

export const getAdminProfile = (token: string): Promise<IAdminSession> =>
  axios
    .get("/api/shopxadmin/me", {
      baseURL: process.env.REACT_APP_ENDPOINT,
      headers: { token },
    })
    .then((res) => res.data);
